<!---================== TITLE FLOW MONITORING FIN ==================--->
<!--&================== TITLE LIBRARY ==================&-->
<div class="title-components">
  <h1>Estatus Proceso</h1>
</div>

<!---================== SECTION FOR BUTTONS ==================--->
<!--&================== TITLE LIBRARY ==================&-->
<div class="divider-butons-FM">

  <!--^====== BUTTON FOR FILTER FIN FOR DATE EXPIRED ======^-->
  <div routerLink="/Dashboard/FIN/SeeDExpirationFIN" class="btn btn-icon-text-left">
    <span class="text">{{!IsExpired ? 'Estatus vencimiento':'Cargas totales'}}</span><i
      class="fa-regular fa-circle-question"></i>
  </div>

  <!--^====== BUTTON FOR OPEN OR CLOSE MODAL HELP ======^-->
  <div (click)="ToggleModalHelp(true)" class="btn btn-icon-text-left">
    <span class="text">Ayuda</span><i class="fa-regular fa-circle-question"></i>
  </div>
</div>


<!---================== SECTION FOR TABLE ==================--->
<div class="container-global-components ConFM">


  <!--^====== SECTION FOR TABLE ======^-->
  <div class="Table-FM Table-container-Global">

    <p-table #dt [value]="ALL_FLOWM_FIN" [(selection)]="SelectedALL_FLOWM_FIN" dataKey="id" [rowHover]="true"
      [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,15,25, 50]" [paginator]="true"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" [filterDelay]="0"
      [globalFilterFields]="GlobalFilterFields">


      <!---================= SEARCH AND ALL FIN =================--->
      <ng-template pTemplate="caption">

        <div class="SectionCreateTotal Table_NG">
          <div class="left-CT">

            <!--?===== INPUT FOR FIN SEARCH =====?-->
            <div class="search inputText">
              <i class="fa-solid fa-magnifying-glass"></i><input [(ngModel)]="Filter_FlowM" type="text"
                (input)="dt.filterGlobal(Filter_FlowM, 'contains')" placeholder="Buscar en estatus Proceso..." />
            </div>
          </div>
          <div class="right-CT">

            <!--?===== INFO OF TOTAL FIN =====?-->
            <div class="AllFiles">Total de Procesos contribuidos:
              <b>{{ALL_FLOWM_FIN.length}}</b><i class="fas fa-file"></i>
            </div>
          </div>
        </div>

      </ng-template>


      <ng-template pTemplate="header">
        <tr>

          <ng-container *ngFor="let Table_header of HeadersFM">

            <ng-container *ngIf="Table_header.Key_Header === 'ROUTE'">
              <th class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === 'NAMFI'">
              <th pSortableColumn="Name" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Name"></p-sortIcon>
                    <p-columnFilter type="text" field="Name" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === 'CODEF'">
              <th class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-columnFilter type="text" field="Code" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === 'NOREV'">
              <th pSortableColumn="Revision_No" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Revision_No"></p-sortIcon>
                    <p-columnFilter field="F_Revision_No" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">No. Revisión</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Revision_No"
                          placeholder="Seleccione" optionLabel="Value" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option.Value}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === 'DESCR'">
              <th pSortableColumn="Purpose" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Purpose"></p-sortIcon>
                    <p-columnFilter type="text" field="Purpose" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>


            <ng-container *ngIf="Table_header.Key_Header.startsWith('APPR')">
              <th pSortableColumn="{{Table_header.Key_Header}}_Name" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="{{Table_header.Key_Header}}_Name"></p-sortIcon>
                    <p-columnFilter field="{{Table_header.Key_Header}}" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Nombre {{Table_header.Name}}</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check[Table_header.Key_Header]"
                          placeholder="Seleccione" optionLabel="Value" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option.Value}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === 'DACRE'">
              <th pSortableColumn="Date_Created" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Date_Created"></p-sortIcon>
                    <p-columnFilter type="date" field="Date_Created" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === 'DAEXP'">
              <th pSortableColumn="Date_Expiration" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Date_Expiration"></p-sortIcon>
                    <p-columnFilter type="date" field="Date_Expiration" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === 'STATU'">
              <th pSortableColumn="Status" class="{{Table_header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_header.Name}}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Status"></p-sortIcon>
                    <p-columnFilter field="F_Status" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Estatus</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" optionLabel="Value" [options]="Filter_Global_Check.Status" placeholder="Seleccione"
                          (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">
                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>
                                  <div [ngSwitch]="option.Value">
                                    <div *ngSwitchCase='1'>Aprobado</div>
                                    <div *ngSwitchCase='2'>Pendiente</div>
                                    <div *ngSwitchCase='3'>Rechazado</div>
                                    <div *ngSwitchDefault></div>
                                  </div>
                                </span>
                              </div>
                            </div>
                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>

                </div>
              </th>
            </ng-container>

          </ng-container>

        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-ALL_FLOWM_FIN>

        <tr>

          <td *ngFor="let Table_header of HeadersFM">

            <ng-container *ngIf="Table_header.Key_Header === 'ROUTE'">
              <div (click)="SeeFINLibrary(ALL_FLOWM_FIN.Path)" class="Btn-Ubication btn-icon-text-left">
                <span class="text">Ubicación de Proceso</span><i class="fa-solid fa-location-arrow"></i>
              </div>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === 'NAMFI'">
              {{ALL_FLOWM_FIN.Name}}
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === 'CODEF'">
              <div class="Description">

                <div class="Text-Description">
                  {{Cut_Code(ALL_FLOWM_FIN.Code)}}
                </div>

                <button (click)="See_Code(ALL_FLOWM_FIN.Code)" *ngIf="ALL_FLOWM_FIN.Code.length > 15"
                  class="Btn-Description">
                  <i class="fa-regular fa-file-lines"></i>
                  <div class="Tool-Tip T-Description">Ver Código</div>
                </button>

              </div>

            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === 'NOREV'">
              {{ALL_FLOWM_FIN.Revision_No}}
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === 'DESCR'">
              <div class="Description">

                <div class="Text-Description">
                  {{Cut_Purpose(ALL_FLOWM_FIN.Purpose)}}
                </div>

                <button (click)="See_Purpose(ALL_FLOWM_FIN.Purpose)" *ngIf="ALL_FLOWM_FIN.Purpose.length > 32"
                  class="Btn-Description">
                  <i class="fa-regular fa-file-lines"></i>
                  <div class="Tool-Tip T-Description">Ver objetivo</div>
                </button>

              </div>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header.startsWith('APPR')">
              <div class="Status-Task">
                <div class="Icon-Status Status{{Get_Dynamic_Approver_Status(ALL_FLOWM_FIN, Table_header.Key_Header)}}">
                  <div><i class="fa-solid {{Icons[Get_Dynamic_Approver_Status(ALL_FLOWM_FIN, Table_header.Key_Header)]?.Icon || 'fa-person-circle-question'}}"></i></div>
                </div>
                <span class="Name"> {{Get_Dynamic_Approver_Name(ALL_FLOWM_FIN, Table_header.Key_Header)}}</span>
              </div>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === 'DACRE'">
              {{DateFormat(ALL_FLOWM_FIN.Date_Created)}}
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === 'DAEXP'">
              <div class="Container-Expired">{{DateFormat(ALL_FLOWM_FIN.Date_Expiration)}}
                <div class="Date-Expired {{Expiry_Status(ALL_FLOWM_FIN.Date_Expiration)}}">
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="Table_header.Key_Header === 'STATU'">
              <div class="ContainerStatus">
                <div class="StatusTool S{{ALL_FLOWM_FIN.Status}}"></div>{{Status_string(ALL_FLOWM_FIN.Status)}}
              </div>
            </ng-container>
          </td>

        </tr>

      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td *ngIf="ALL_FLOWM_FIN.length>0" colspan="8">Sin coincidencias.</td>
        </tr>
        <tr>
          <td colspan="20">
            <!--^====== NOT FIN CONTRIBUTION OR NOT FIN SOON TO EXPIRE ======^-->
            <div class="Not-FM" *ngIf="ALL_FLOWM_FIN.length===0 && LoadPage">
              <div class="Img-Not">
                <img src="./assets/Global/Ilustrations/Not-Contribution.png" alt="">
              </div>
              <div class="Text-Not-FM">
                ¡{{GetGreeting()}}, {{NameUser()}}, no tiene ningún Proceso {{!IsExpired ? 'contribuido pendiente':'próximo a expirar'}}!
              </div>
            </div>
          </td>
        </tr>
      </ng-template>

    </p-table>

  </div>

</div>


<!---===================== MODAL FOR HELP ICONS =====================--->
<section class="Modal-Global" id="ModalIconsHelp">
  <div class="wrapper">
    <div class="Local-M-Icon-Popup popup">
      <div class="Local-M-Icon-inside popup-inside">
        <div class="Local-M-Icon-backgrounds backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>
      <div class="Local-M-Icon-content content">
        <div (click)=" ToggleModalHelp(false)" class="Btn-Close"><i class="fa-solid fa-xmark"></i></div>
        <div class="Content-Top">
          <h2>Iconografía</h2>
        </div>

        <div class="Content-body">
          <div class="Info-Icons">
            <div class="Header grid-column-2">
              <div class="Icon-container">
                Icono
              </div>
              <div class="Description">
                Descripción
              </div>
            </div>
            <div *ngFor="let icon of Icons;let i = index" class="grid-column-2">
              <div class="Icon-container">
                <div class="Icon-Status Status{{i}}">
                  <div><i class="fa-solid {{Icons[i].Icon}}"></i></div>
                </div>
              </div>
              <div class="Description">
                {{icon.Description}}
              </div>
            </div>

          </div>
        </div>
        <div class="Local-M-Icon-Bottom Content-Bottom">
          <div (click)=" ToggleModalHelp(false)" class="Btn-Close-Modal">
            <span>Cerrar</span>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>


<!---===================== LOADER =====================--->
<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>
